export enum TipoComparativa{
    Tanque15,
    TanquesNaturales,
    Aeroespecialidades
}